(function(){
  'use strict';
  if(window.__PMY_PDP_LAUNCH_FINAL__)return;
  window.__PMY_PDP_LAUNCH_FINAL__=true;

  function isPdp(){
    return !!document.querySelector('.pdp-container[data-pmy-use-global-drawer="true"]');
  }

  function fitTitle(){
    var title=document.querySelector('.pdp-title');
    var header=document.querySelector('.pdp-page-header');
    if(!title||!header)return;
    title.classList.remove('pmy-title-wrap');
    if(window.innerWidth<1200)return;
    window.requestAnimationFrame(function(){
      if(title.scrollWidth>header.clientWidth-4)title.classList.add('pmy-title-wrap');
    });
  }

  function moveShareRail(){
    var rail=document.getElementById('pmy-product-share-rail');
    var main=document.querySelector('.pdp-main-content');
    if(rail&&main&&rail.parentNode!==main)main.appendChild(rail);
  }

  function lazyMap(){
    var frame=document.querySelector('[data-pmy-map-src]');
    if(!frame||frame.getAttribute('src'))return;
    var load=function(){
      if(!frame.getAttribute('src')){
        frame.setAttribute('src',frame.getAttribute('data-pmy-map-src')||'');
      }
    };
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        if(entries.some(function(e){return e.isIntersecting;})){
          io.disconnect();
          load();
        }
      },{rootMargin:'700px 0px'});
      io.observe(frame);
    }else{
      load();
    }
  }

  function boot(){
    if(!isPdp())return;
    document.documentElement.classList.add('pmy-pdp-global-drawer');
    document.body.classList.add('pmy-pdp-global-drawer');
    fitTitle();
    moveShareRail();
    lazyMap();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();

  window.addEventListener('resize',fitTitle,{passive:true});
  document.addEventListener('shopify:section:load',function(){window.setTimeout(boot,0);});
})();